<template>
  <div class="inspectiondetail--hero">
    <AgreementsCallouts
      :agreements="inspection.agreements"
      :inspector-phone-number="companyPhone"
      :show-success="agreementsSuccess"
      :show-warning="agreementsWarning"
      @closeSuccess="emitCloseSuccess"
      @closeWarning="emitCloseWarning" />

    <InspectionStatusDetail
      :hg-company-id="companyId"
      :hg-folder-id="folderId"
      :hg-folder-status="inspection.folderStatus" />

    <RequestList
      :hg-eligible-reports="crlEligibleInspectionReports"
      :hg-folder-status="inspection.folderStatus"
      :hg-request-lists="inspection.requestLists"
      @copy="emitCopy" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import AgreementsCallouts from './AgreementsCallouts.vue';
import InspectionStatusDetail from './InspectionStatus/InspectionStatusDetail.vue';
import RequestList from './RequestList/RequestList.vue';

export default {
  components: {
    AgreementsCallouts,
    InspectionStatusDetail,
    RequestList,
  },
  props: {
    agreementsSuccess: {
      type: Boolean,
      default: false,
    },
    agreementsWarning: {
      type: Boolean,
      default: false,
    },
    folderId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('Inspection', {
      inspection: state => state.inspection,
    }),
    ...mapGetters('Inspection', [
      'crlEligibleInspectionReports',
    ]),
    companyId() {
      return this.inspection.company
        ? this.inspection.company.id
        : 0;
    },
    companyPhone() {
      return this.inspection.company
        ? this.inspection.company.phone
        : '';
    },
  },
  methods: {
    emitCloseSuccess() {
      this.$emit('closeSuccess');
    },
    emitCloseWarning() {
      this.$emit('closeWarning');
    },
    emitCopy(crlId) {
      this.$emit('copy', crlId);
    },
  },
};
</script>
